import { PageController } from '@client/components/_core/layout/PageController';
import { Tabs } from '@client/components/_core/navigation/Tabs';
import { createFileRoute } from '@tanstack/react-router';
import { Settings2 } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/configuration/compliance/complaints/general')({
    staticData: {
        metadata: {
            title: 'General',
        },
        ui: {
            icon: Settings2,
            title: 'Complaint settings',
            useTitleForChildren: true,
            subtitle: 'Lodgement link, acknowledgements and timeline',
            menuDescription: 'Lodgement link, acknowledgements and timeline',
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <Tabs
                items={[
                    {
                        label: 'Lodgement and acknowledgements',
                        to: '/console/$orgId/configuration/compliance/complaints/general/lodgement',
                    },
                    {
                        label: 'Timeline',
                        to: '/console/$orgId/configuration/compliance/complaints/general/timeline',
                    },
                ]}
            />
        </PageController>
    );
}
